export default __webpack_public_path__ + "static/media/Majeed-Logo-white.2f4373b7.png";